import React, { Component } from "react";
import { verifyUser } from "../../services/apiServices";
import request from "../../services/requestService";
import { setLocalstorage } from "../../helper";
import { LoaderPage } from "../Loader";
import { PATHS } from "../../constant";

class PmgProject extends Component {
  getAccessToken = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.slice(1));

    const projectId = queryParams.get("projectId");
    const accessToken_t = hashParams.get("t");

    return {
      projectId,
      accessToken_t
    };
  };

  componentDidMount = async () => {
    const { history } = this.props;
    const { projectId, accessToken_t } = this.getAccessToken();
    //console.log('In pmg project accessToken_t', accessToken_t);
    if (!accessToken_t) {
      window.location.href = "/login";
      return;
    }
    try {
      const verifyUserResponse = await request(verifyUser(accessToken_t));

      if (verifyUserResponse.status === 200) {
        const userData = verifyUserResponse.data.data;
        setLocalstorage("token", accessToken_t || null);

        setLocalstorage("name", userData.user.name || null);
        setLocalstorage("logoDTO", userData.user.logoDTO || null);
        //           setLocalstorage(
        //             "needHelpEmails",
        //             payload.data.user.needHelpEmails || null
        //           );
        setLocalstorage("user", userData.user || null);
        setLocalstorage(
          "userSponsoredScheme",
          userData.user.sponsoredScheme === "STATE"
        );
        setLocalstorage("draftedProject", userData.user.projectDrafted || null);
        setLocalstorage("groupCategory", userData.user.groupCategory || null);
        setLocalstorage("userId", userData.user.userID || null);
        setLocalstorage("march24", false);
        window.location.href = `/detail-project?projectId=${projectId}`;
        return;
      } else {
        //window.location.href = '/login';
        history.push(PATHS.LOGIN);
        return;
      }
    } catch (error) {
      //window.location.href = '/login';
      history.push(PATHS.LOGIN);
    }
  };
  render() {
    return (
      <>
        <LoaderPage loading={true} />
      </>
    );
  }
}

export default PmgProject;
